import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-application-success-page',
    templateUrl: './application-success-page.component.html',
    styleUrls: ['./application-success-page.component.scss'],
    standalone: false
})
export class ApplicationSuccessPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
